export default __webpack_public_path__ + "static/media/kanit-medium.5cc82e75.eot";